import routeUtils from '../utils/routeUtils';

import systemRoute from './systemRoute';
// import dashboardRoute from './dashboardRoute';
import cwpRoute from './cwpRoute';
// import vmcRoute from './vmcRoute';

// import dcrSummaryRoute from './dcrSummaryRoute';

import marketingMaterialRoute from './marketingMaterialRoute';
// import perMDViewRoute from './perMDViewRoute';

// import rbaSummaryRoute from './rbaSummaryRoute';
// import vmcMaintenanceRoute from './vmcMaintenanceRoute';
import areaImprovementRoute from './areaImporvementRoute';
import crmDashboardRoute from './crmDashboardRoute';
import dcrViewerRoute from './dcrViewerRoute';
import managerDashboard from './managerDashboard';
import ninetyninetyReporRoute from './ninetyninetyReporRoute';
import PMdashboardRoute from './PMdashboardRoute';
import hcpDashboardRoute from './hcpDashboardRoute';
import PRDDashboardRoute from './prdDashboardRoute';
import productAllocationRoute from './productAllocationRoute';
import productInventoryBalancev2Route from './productInventoryBalancev2Route';
import ProductSamplingInventoryMaintenance from './productSamplingInventory';
import HospitalCoverateRoute from './hospitalCoverateRoute';
import productSamplingRoute from './productSamplingRoute';
import teamDashboardRoute from './teamDashboardRoute';
import SalesWeeklyReportRoute from './salesReportRoute';
import ReportGeneratorRoute from './reportGeneratorRoute';
import targetMaintenance from './targetMaintenanceRoute';
import wwwRoute from './wwwRoute';
import eventCalendarRoute from './eventCalendarRoute';
import fieldEngagementRoute from './fieldEngagementRoute';
import ccoDashboardRoute from './clientCallOutRoute';
import MdProfileDashboardRoute from './mdProfileDashboard';
import MdMastelistRoute from './mdMastelistRoute';
import footprintReportRoute from './footprintReportRoute';
import feedbackRoute from './feedbackRoute';
import productSamplingv2Route from './productSamplingv2Route';

export default routeUtils.combineRoutes([
  systemRoute,
  // dashboardRoute,
  cwpRoute,
  // vmcRoute,
  // dcrSummaryRoute,
  // feedbackRoute,
  marketingMaterialRoute,
  // perMDViewRoute,
  // rbaSummaryRoute,
  // vmcMaintenanceRoute,
  dcrViewerRoute,
  managerDashboard,
  targetMaintenance,
  ninetyninetyReporRoute,
  PMdashboardRoute,
  hcpDashboardRoute,
  productSamplingRoute,
  teamDashboardRoute,
  SalesWeeklyReportRoute,
  ProductSamplingInventoryMaintenance,
  HospitalCoverateRoute,
  ReportGeneratorRoute,
  PRDDashboardRoute,
  productAllocationRoute,
  productInventoryBalancev2Route,
  areaImprovementRoute,
  wwwRoute,
  eventCalendarRoute,
  crmDashboardRoute,
  fieldEngagementRoute,
  ccoDashboardRoute,
  MdProfileDashboardRoute,
  MdMastelistRoute,
  footprintReportRoute,
  feedbackRoute,
  productSamplingv2Route,
]);
